import { useState } from 'react';

export default function Testimonials() {
  const testimonials = [
    {
      quote: "The attention to detail is remarkable. Our office has never looked better, and their team is incredibly professional and reliable. They've transformed our workspace into a pristine environment that our employees love.",
      author: 'Sarah Johnson'
    },
    {
      quote: "Switching to First Insight Cleaning was the best decision we made. Their eco-friendly approach aligns with our company values, and the quality of service is outstanding. Our clients always comment on how clean our facility is.",
      author: 'Michael Chen'
    },
    {
      quote: "As a medical facility, cleanliness is paramount. First Insight Cleaning's specialized medical cleaning services exceed all our requirements. Their staff is trained, certified, and always goes above and beyond.",
      author: 'Dr. Emily Rodriguez'
    }
  ];

  const [currentIndex, setCurrentIndex] = useState(0);

  const nextTestimonial = () => {
    setCurrentIndex((prev) => (prev + 1) % testimonials.length);
  };

  const prevTestimonial = () => {
    setCurrentIndex((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  const current = testimonials[currentIndex];

  return (
    <section id="testimonials" className="py-20 bg-slate-50">
      <div className="max-w-4xl mx-auto px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-12">
          <div className="text-sm text-slate-500 mb-2">(Client Success Stories)</div>
          <h2 className="text-4xl lg:text-5xl font-bold mb-2 font-['Poppins']">
            <span className="text-slate-800">What Our Clients Say</span>
          </h2>
          <h3 className="text-2xl lg:text-3xl font-bold text-slate-400 font-['Poppins']">
            About Our Service
          </h3>
        </div>

        {/* Testimonial Card */}
        <div className="bg-white rounded-3xl shadow-lg p-8 lg:p-12">
          {/* Quote */}
          <div className="text-center">
            <i className="ri-double-quotes-l text-5xl text-teal-500 opacity-50"></i>
            <p className="text-xl text-slate-700 leading-relaxed mt-4 mb-8">
              {current.quote}
            </p>
            <div className="flex items-center justify-center gap-4">
              <div className="w-14 h-14 flex items-center justify-center bg-teal-500 rounded-full">
                <span className="text-white font-bold text-xl">
                  {current.author.charAt(0)}
                </span>
              </div>
              <div className="text-left">
                <div className="font-bold text-slate-800 text-lg">{current.author}</div>
              </div>
            </div>
          </div>
        </div>

        {/* Navigation */}
        <div className="flex items-center justify-center gap-6 mt-8">
          <button
            onClick={prevTestimonial}
            className="w-12 h-12 flex items-center justify-center rounded-full border-2 border-slate-300 text-slate-400 hover:border-teal-500 hover:text-teal-500 transition-all duration-300 cursor-pointer"
          >
            <i className="ri-arrow-left-line text-xl"></i>
          </button>

          {/* Indicators */}
          <div className="flex gap-2">
            {testimonials.map((_, index) => (
              <button
                key={index}
                onClick={() => setCurrentIndex(index)}
                className={`h-2 rounded-full transition-all duration-300 cursor-pointer ${
                  index === currentIndex ? 'w-8 bg-teal-500' : 'w-2 bg-slate-300'
                }`}
              />
            ))}
          </div>

          <button
            onClick={nextTestimonial}
            className="w-12 h-12 flex items-center justify-center rounded-full bg-teal-500 text-white hover:bg-teal-600 transition-all duration-300 cursor-pointer"
          >
            <i className="ri-arrow-right-line text-xl"></i>
          </button>
        </div>
      </div>
    </section>
  );
}
